import React, { Component, Fragment } from 'react';
import config from 'configs';
import KambriaWallet from '@kambria/kambria-wallet';
import { unit } from '@kambria/kambria-util';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { watchInfo } from 'modules/blockchain.reducer';

import { Button } from '@kambria/kambria-lego';

import katIcon from 'static/svg/ic-coin.svg';
import ethIcon from 'static/images/eth-icon.png';
import kambriaIcon from 'static/svg/logo-kambria-token.svg';
const style = {
  backgroundImage: `url(${kambriaIcon})`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  width: '96px',
  height: '96px',
  marginTop: "36px",
  position: 'absolute'
}

class Info extends Component {
  constructor() {
    super();

    this.state = {
      show: false,
      info: false,
      walletOptions: {
        networkId: {
          ethereum: config.eth.NETWORK.ID,
        },
        pageRefreshing: true
      }
    }
  }

  done = (er, re) => {
    this.setState({ show: false }, () => {
      if (er) return console.error(er);
      if (re) return this.props.watchInfo();
    });
  }

  disconnect = () => {
    if (window.kambriaWallet) window.kambriaWallet.logout();
    this.props.watchInfo(); // Reset redux state
    this.checkProvider(); // Reset render
  }

  checkProvider = () => {
    if (!window.kambriaWallet || !window.kambriaWallet.provider) {
      if (this.state.info) return this.setState({ info: false });
    }
    else {
      if (!this.state.info) return this.setState({ info: true });
    }
  }

  showKambriaWallet = () => {
    this.setState({ show: false }, () => {
      this.setState({ show: true });
    });
  }

  connectWithWallet = () => {
    if (this.state.info) return null;

    return <div id="connect-wallet" className="container px-0 position-relative">
      <div className="mx-auto text-center mt-3" style={{ "color": "#B90E1E", "fontSize": "24px" }}>Wallet Required</div>
      <div className="mx-auto text-center mt-2" style={{ "color": "#FFFFFF", "fontSize": "16px" }}>You have to connect with your wallet to use all functions</div>
      <Button
        type="primary"
        size="sm"
        className="mx-auto text-center mt-2 d-block"
        onClick={this.showKambriaWallet}
      >Connect</Button>
    </div>
  }

  info = () => {
    if (!this.state.info) return null;
    let { account, kat, balance } = this.props.blockchain;
    let networkComponent = config.eth.NETWORK.LABEL;
    let balanceComponent = <tr>
      <td style={{ "paddingRight": "32px" }}>Balance</td>
      <td><img src={katIcon} alt="kat" /> {unit.wkat2KAT(kat)} {config.eth.TOKEN.UNIT}</td>
      <td style={{ "paddingRight": "128px" }}><img src={ethIcon} alt="eth" /> {unit.wei2ETH(balance)} ETH</td>
    </tr>

    return <div className="container px-0 position-relative">
      <div className="kambria-icon float-left" style={style}></div>
      <p className="mainnet float-left">{networkComponent}</p>
      <button
        className="btn btn-secondary btn-sm"
        style={{ position: "absolute", top: "32px", left: "210px" }}
        onClick={this.disconnect}>Disconnect</button>
      <table className="hero-table">
        <tbody>
          <tr>
            <td style={{ "paddingRight": "32px" }}>Your Wallet</td>
            <td colSpan="2">{account}</td>
          </tr>
          {balanceComponent}
        </tbody>
      </table>
    </div>
  }

  componentDidMount() {
    this.setState({ show: false });
  }

  componentDidUpdate() {
    this.checkProvider();
  }

  render() {
    return <Fragment>
      {this.connectWithWallet()}
      {this.info()}
      <KambriaWallet visible={this.state.show} options={this.state.walletOptions} done={this.done} />
    </Fragment>;
  }
}

const mapStateToProps = state => ({
  blockchain: state.blockchain,
  kat: state.kat
});

const mapDispatchToProps = dispatch => bindActionCreators({
  watchInfo: () => watchInfo()
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Info);